<template lang="pug">
.dots(:class="`${small ? 'small' : ''}`")
  .dots-inner(@click.prevent.stop="drop", :class="`${dropped ? 'dropped' : ''}`")
    span
  .dropper(v-if="dropped", v-click-outside="clickedOutsideDropper")
    slot
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropped: false,
    };
  },
  methods: {
    /**
     * Hide the dropper and emit that we click outside
     */
    clickedOutsideDropper() {
      this.dropped = false;
      this.$emit('clickedOutside', true);
      this.$emit('dropped', false);
    },
    /**
     * Toggle the drop
     */
    drop() {
      if (this.disabled) {
        return;
      }

      const dropped = !this.dropped;

      setTimeout(() => {
        this.dropped = dropped;
      }, 50);
    },
    close() {
      this.dropped = false;
      this.$emit('dropped', false);
    },
  },
};
</script>

<style lang="scss" scoped>

@use 'sass:math';

$dotSize: 6px;
$dotSmallSize: 4px;
$dropperWidth: 200px;

.dots {
  position: relative;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  .dots-inner {
    padding-left: $dotSize + math.div($dotSize, 2);
    padding-right: $dotSize + math.div($dotSize, 2);
    &:hover {
      cursor: pointer;
    }

    &.dropped {
      span:after {
        right: 0;
        top: -10px;
      }

      span:before {
        left: 0;
        top: 10px;
      }
    }
  }


  span {
    display: inline-block;
    background-color: #0360FF;
    border-radius: math.div($dotSize, 2);
    height: $dotSize;
    width: $dotSize;
    position: relative;

    &:before, &:after {
      content: "";
      background-color: #0360FF;
      border-radius: math.div($dotSize, 2);
      height: $dotSize;
      width: $dotSize;
      position: absolute;
    }

    &, &:before, &:after {
      transition: all .3s;
    }

    &:before {
      left: -10px;
      top: 0;
      bottom: 0;
    }

    &:after {
      right: -10px;
      top: 0;
      bottom: 0;
    }
  }

  .dropper {
    // background-color: white;
    // border: 1px solid #B7BDC6;
    // border-radius: 5px;
    // box-shadow: 2px 2px 0 #CED4DE;
    position: absolute;
    top: calc(100% + 5px);
    left: ($dotSize + math.div($dotSize, 2) * 3);
    transform: translateX(-50%);
    z-index: 100;
    width: $dropperWidth;

    background: var(--color-context-menu);
    border-radius: 2px;
    box-shadow: 0 1px 6px 0 rgb(80 153 225 / 20%), 0 1px 1px 0 rgb(80 153 225 / 20%);

    &:before, &:after {
      bottom: 100%;
      left: 50%;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: var(--color-context-menu);
      border-width: 8px;
      margin-left: -8px;
    }

    &:before {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: var(--color-context-menu);
      border-width: 8px;
      margin-left: -8px;
    }

    ul {
      & > * {
        align-items: center;
        color: #fff;
        display: flex;
        padding: 8px 16px;
        font-size: 15px;
        font-weight: 500;
        line-height: 22px;

        i {
          margin-right: .5rem;
          font-size: 1.2rem;
          line-height: 1;
        }

        &:last-child {
          border-bottom: 0;
        }

        &:hover {
          background: var(--color-context-menu-hover);
          color: var(--color-notification-blue);
          cursor: pointer;
        }

        &:first-child {
          &:hover {
            border-radius: 5px 5px 0 0;
          }
        }

        &:last-child {
          &:hover {
            border-radius: 0 0 5px 5px;
          }
        }

        &:only-child {
          &:hover {
            border-radius: 5px;
          }
        }

        &.disabled {
          pointer-events: none;
          opacity: .5;
        }

        /*&.red {
          color: #D0021B;
        }

        &.orange {
          color: #FF8429;
        }

        &.green {
          color: #00BB5F;
        }*/
      }
    }
  }

  &.small {
    .dots-inner {
      padding-left: $dotSmallSize + math.div($dotSmallSize, 2);
      padding-right: $dotSmallSize + math.div($dotSmallSize, 2);
      display: flex;
      align-items: center;
      height: 16px;
      width: 16px;

      &.dropped {
        span:before {
          top: -7px;
        }

        span:after {
          top: 7px;
        }
      }
    }
    span {
      border-radius: math.div($dotSmallSize, 2);
      height: $dotSmallSize;
      width: $dotSmallSize;

      &:before, &:after {
        border-radius: math.div($dotSmallSize, 2);
        height: $dotSmallSize;
        width: $dotSmallSize;
      }

      &:before {
        left: -7px;
      }

      &:after {
        right: -7px;
      }
    }

    .dropper {
      left: ($dotSmallSize + math.div($dotSmallSize, 2) * 3);
    }
  }

  &.border {
    border-width: 0;
    .dots-inner {
      border: 1px solid #0360FF;
      height: 32px;
      width: 32px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 0;

      @media (min-width: 1024px) {
        height: 40px;
        width: 40px;
      }
    }
  }

  &.white {
    align-items: center;
    background-color: white;
    border-radius: 16px;
    box-shadow: 0 1px 6px 0 rgb(80 153 225 / 20%), 0 1px 1px 0 rgb(80 153 225 / 20%);
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
  }

  &.left {
    .dropper {
      transform: translateX(-91%);
      &:before, &:after {
        left: 90%;
      }
    }

    &.small {
      .dropper {
        transform: translateX(-87%);
        top: calc(100% + 4px);
        &:before, &:after {
          left: 90%;
        }
      }
    }
  }
  &.left-center {
    .dropper {
      transform: translateX(-91%);
      left: -30px;
      top: calc(100% + -37px);
      &:before, &:after {
        left: 100%;
        transform: rotate(90deg);
        margin-left: 0;
      }

      &:before {
        bottom: calc(100% - 31px)
      }

      &:after {
        bottom: calc(100% - 30px)
      }
    }
  }

  &.right {
    .dropper {
      transform: translateX(-11%);
      &:before, &:after {
        left: 10%;
      }
    }
  }
}
</style>
